var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M0.574707 6C1.20137 2.58667 4.19271 0 7.78737 0C11.382 0 14.3727 2.58667 15 6C14.3734 9.41333 11.382 12 7.78737 12C4.19271 12 1.20204 9.41333 0.574707 6ZM7.78737 9.33333C8.67143 9.33333 9.51927 8.98214 10.1444 8.35702C10.7695 7.7319 11.1207 6.88405 11.1207 6C11.1207 5.11595 10.7695 4.2681 10.1444 3.64298C9.51927 3.01786 8.67143 2.66667 7.78737 2.66667C6.90332 2.66667 6.05547 3.01786 5.43035 3.64298C4.80523 4.2681 4.45404 5.11595 4.45404 6C4.45404 6.88405 4.80523 7.7319 5.43035 8.35702C6.05547 8.98214 6.90332 9.33333 7.78737 9.33333ZM7.78737 8C7.25694 8 6.74823 7.78929 6.37316 7.41421C5.99809 7.03914 5.78737 6.53043 5.78737 6C5.78737 5.46957 5.99809 4.96086 6.37316 4.58579C6.74823 4.21071 7.25694 4 7.78737 4C8.31781 4 8.82651 4.21071 9.20159 4.58579C9.57666 4.96086 9.78737 5.46957 9.78737 6C9.78737 6.53043 9.57666 7.03914 9.20159 7.41421C8.82651 7.78929 8.31781 8 7.78737 8Z",
    fill: "#023E8A",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeBlue);
export default __webpack_public_path__ + "static/media/eyeBlue.78158d8a208316afeb49dbee43ce3f5e.svg";
export { ForwardRef as ReactComponent };